module.exports = __webpack_public_path__ + "img/ad-03.84e16b5c.png";